import { __extends } from "tslib";
import { Entity } from '../../base/ddd-types/entity';
import { VipInfo } from '../value-object/vip-info';
import { ACCOUNT_TYPE } from '@tencent/ark-utils/lib/base/types';
var UserInfo = /** @class */ (function (_super) {
    __extends(UserInfo, _super);
    function UserInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ValueObject的属性必须在这里初始化了， 才能正确的使用equals和jsonObj方法
        _this.avatar = '';
        _this.qqAvatar = '';
        _this.wxAvatar = '';
        _this.nick = '';
        _this.qqNick = '';
        _this.wxNick = '';
        _this.corpId = '';
        _this.corpName = '';
        _this.domain = '';
        _this.domainId = '';
        _this.dbEmail = '';
        _this.email = '';
        _this.tinyid = '';
        _this.toid = '';
        _this.userId = '';
        _this.uid = '';
        _this.wxOpenid = '';
        _this.uidSource = 0;
        _this.uin = '';
        _this.login = false;
        _this.loginTime = 0;
        _this.loginType = ACCOUNT_TYPE.UNKNOWN;
        _this.xu = '';
        _this.vipInfo = new VipInfo({});
        _this.vip = '';
        _this.userPic = '';
        return _this;
    }
    return UserInfo;
}(Entity));
export { UserInfo };
